import { render, staticRenderFns } from "./PageReportSales.vue?vue&type=template&id=32c3d048&"
import script from "./PageReportSales.vue?vue&type=script&lang=js&"
export * from "./PageReportSales.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports